import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar.jsx";
import Home from "./pages/Home.jsx";
import ProjectDetails from './pages/ProjectDetails.jsx';
import Gallery from './pages/Gallery';
import Location from './pages/Location';
import Contact from './pages/Contact';
import Footer from "./components/Footer.jsx";
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ScrollToTop from "./components/ScrollToTop";
import FloatingActions from './common/FloatingActions';
import ThankYou from "./common/ThankYou";
import VillaDetail from "./pages/VillaDetail.jsx";


function App() {
  return (
    <>
      <Navbar />
       <ScrollToTop />
       <FloatingActions/>

      <main className="min-h-[70vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/villa/:villaId" element={<VillaDetail />} />
          <Route path="/project" element={<ProjectDetails/>} />
          <Route path="/gallery" element={<Gallery/>}/>
          <Route path="/location" element={<Location/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions/>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        </Routes>
      </main>

      <Footer />
    </>
  );
}

export default App;
